import { IIconButtonComponent, IIconComponent, ITooltipComponent } from "@tylertech/forge";
import { getLoggerFor } from "@tylertech/logging";
import { SmartPulsePlugin } from "@tylertech/smart-pulse-core";
import { CHAT_SIDEBAR_SERVICE_TOKEN } from "@tylertech/smart-pulse-foundry-chat-sidebar";
import { BrowserNotificationKeys } from "../../../services";
export function createBrowserNotificationPlugin(browserCheckOnEnabled: () => void, getCurrentPermission: () => boolean | null): SmartPulsePlugin
{
    return {
        id: "browser-notification",
        requiresPlugins: ["framework-menu-forge-driver"],
        requiresTokens: [CHAT_SIDEBAR_SERVICE_TOKEN],
        init: () => { return; },
        afterInit: (container) =>
        {
            const api = container.tryResolve(CHAT_SIDEBAR_SERVICE_TOKEN);
            const component = api?.getComponent();
            if (!api || !component)
            {
                //TODO:  Maybe we should disable notifications completely?  The only way, though, is to force the storage as false, so I am not sure if we want to...
                getLoggerFor("BrowserNotificationPlugin").warning("Browser Notifications toggle not started.",
                    { hasApi: !!api, hasComponent: !!component });
                return;
            }

            const setKeyState = (currentState: string, bypassCheck?: boolean) =>
            {
                window.localStorage.setItem(BrowserNotificationKeys.SMARTPULSE_NOTIFICATION_KEY, currentState);
                if (currentState === "yes" && !bypassCheck)
                    browserCheckOnEnabled();
            };
            const setButtonState = (button: IIconButtonComponent, icon: IIconComponent, tooltip: ITooltipComponent, value: string) =>
            {
                icon.setAttribute("name", value === "yes" ? "notifications_active" : "notifications_none");
                tooltip.textContent = value === "yes" ? "Toggle notifications off" : "Toggle notifications on";
                button.ariaLabel = value === "yes" ? "Notifications Toggle - On" : "Notifications Toggle - Off";
                button.name = value === "yes" ? "Notifications Toggle - On" : "Notifications Toggle - Off";
            };

            let areNotificationsAllowed = window.localStorage
                .getItem(BrowserNotificationKeys.SMARTPULSE_NOTIFICATION_KEY);

            if (areNotificationsAllowed === null)
            {
                //If the value actually is default, we should default it to true so if they actually want to use, it allows.
                //If they do not, it will be true, but still do toast messages.
                areNotificationsAllowed = getCurrentPermission() === false ? "no" : "yes";
                setKeyState(areNotificationsAllowed, true);
            }

            const button = document.createElement("forge-icon-button");
            button.slot = "header-actions";
            const icon = document.createElement("forge-icon");
            const tooltip = document.createElement("forge-tooltip");
            tooltip.setAttribute("placement", "bottom");
            setButtonState(button, icon, tooltip, areNotificationsAllowed);

            button.appendChild(tooltip);
            button.appendChild(icon);
            component.appendChild(button);

            button.addEventListener("click", () =>
            {
                let currentValue = window.localStorage
                    .getItem(BrowserNotificationKeys.SMARTPULSE_NOTIFICATION_KEY);

                if (currentValue === "yes")
                    currentValue = "no";
                else
                    currentValue = "yes";

                setKeyState(currentValue);
                setButtonState(button, icon, tooltip, currentValue);

            });
        }
    };

}